import { styled } from '@mui/material/styles';
import { Box, Typography, Button, TextField, Select, TableCell, TableRow } from '@mui/material';

// ============================================
// Table Controls
// ============================================
export const TableControlsRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
});

export const PageSizeGroup = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const PageSizeLabel = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  color: '#737373',
});

export const PageSizeSelect = styled(Select)({
  height: '40px',
  minWidth: '80px',
  backgroundColor: '#fff',
  borderRadius: '8px',
  fontSize: '14px',
  color: '#737373',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#d9d9d9',
  },
});

export const SearchGroup = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const SearchInput = styled(TextField)({
  width: '320px',
  '& .MuiOutlinedInput-root': {
    height: '40px',
    borderRadius: '8px',
    backgroundColor: '#fff',
    fontSize: '14px',
    '& fieldset': {
      borderColor: '#d9d9d9',
    },
  },
  '& .MuiInputBase-input::placeholder': {
    color: '#a6a6a6',
    opacity: 1,
  },
});

export const SearchButton = styled(Button)({
  height: '40px',
  minWidth: '100px',
  backgroundColor: '#4ab3bc',
  borderRadius: '8px',
  fontSize: '16px',
  fontWeight: 600,
  color: '#fff',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#3da3ab',
  },
});

// ============================================
// Table
// ============================================
export const HeaderCell = styled(TableCell)({
  fontSize: '14px',
  fontWeight: 600,
  color: '#262626',
  textAlign: 'center',
  padding: '12px',
  backgroundColor: '#f2f2f2',
  borderBottom: '1px solid #d9d9d9',
  whiteSpace: 'nowrap',
});

export const BodyCell = styled(TableCell)({
  fontSize: '14px',
  fontWeight: 500,
  color: '#262626',
  textAlign: 'center',
  padding: '12px',
  borderBottom: '1px solid #d9d9d9',
  whiteSpace: 'nowrap',
});

export const DataRow = styled(TableRow)({
  backgroundColor: '#fff',
  height: '56px',
});

export const BalanceText = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
  color: '#262626',
});

// ============================================
// Actions
// ============================================
export const ActionGroup = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
});

export const GrantButton = styled(Button)({
  height: '32px',
  padding: '4px 16px',
  fontSize: '14px',
  fontWeight: 600,
  color: '#4ab3bc',
  backgroundColor: '#fff',
  border: '1px solid #4ab3bc',
  borderRadius: '4px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#f0fafb',
  },
});

export const RevokeButton = styled(Button)({
  height: '32px',
  padding: '4px 16px',
  fontSize: '14px',
  fontWeight: 600,
  color: '#737373',
  backgroundColor: '#fff',
  border: '1px solid #d9d9d9',
  borderRadius: '4px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
  '&.Mui-disabled': {
    color: '#bfbfbf',
    borderColor: '#e0e0e0',
  },
});

// ============================================
// Pagination
// ============================================
export const PaginationContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  width: '100%',
});

export const PageButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'isActive',
})(({ isActive }) => ({
  minWidth: '40px',
  height: '40px',
  padding: '10px',
  fontSize: '14px',
  fontWeight: 500,
  color: isActive ? '#fff' : '#262626',
  backgroundColor: isActive ? '#58b9c1' : '#fff',
  border: isActive ? 'none' : '1px solid #d9d9d9',
  borderRadius: '4px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: isActive ? '#4aa8b0' : '#f5f5f5',
  },
}));

export const NavButton = styled(Button)({
  minWidth: '40px',
  height: '40px',
  padding: '10px',
  backgroundColor: '#fff',
  border: '1px solid #d9d9d9',
  borderRadius: '4px',
  color: '#262626',
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
});
